import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import { type Arena } from '@/types/arena.type'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import axiosInstance, { endpoints } from '@/lib/axios'
import LoadingSection from '@/components/loading-indicator/loading-section'

import ArenaForm from '../arena-form'

export default function ArenaFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [arena, setArena] = useState<Arena | undefined>(undefined)
  const isEditMode = params.id !== undefined

  useEffect(() => {
    const fetchArena = async () => {
      if (!isEditMode || !params.id) {
        loading.onFalse()
        return
      }

      try {
        loading.onTrue()
        const { data } = await axiosInstance.get<Arena>(
          endpoints.arenas.detail(params.id),
        )
        setArena(data)
      } catch (error) {
        toast.error(fError(error))
      } finally {
        loading.onFalse()
      }
    }

    fetchArena()
  }, [isEditMode, params.id])

  return (
    <LoadingSection loading={loading.value}>
      <ArenaForm arena={arena} mode={isEditMode ? 'edit' : 'create'} />
    </LoadingSection>
  )
}
